import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { SETTINGS_COLLECTION } from "../../constants";
import db from "../../firebaseConfig";
import LoadingIndicator from "../layouts/LoadingIndicator";

const PaymentSettingPage = () => {
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [payments, setPayments] = useState(null);

    const history = useHistory();

    const { register, handleSubmit, formState: { errors } } = useForm();
    
    const onBankSubmit = async data => {
        setIsSubmitting(true);
        const paymentsSettings = {
            bank_dbbl: data.bank_dbbl,
            // bkash: data.bkash,
            // rocket: data.rocket,
            // nagad: data.nagad,
        };
        await submit(paymentsSettings);
    };
    
    const onBkashSubmit = async data => {
        setIsSubmitting(true);
        const paymentsSettings = {
            // bank_dbbl: data.bank_dbbl,
            bkash: data.bkash,
            // rocket: data.rocket,
            // nagad: data.nagad,
        };
        await submit(paymentsSettings);
    };
    
    const onRocketSubmit = async data => {
        setIsSubmitting(true);
        const paymentsSettings = {
            // bank_dbbl: data.bank_dbbl,
            // bkash: data.bkash,
            rocket: data.rocket,
            // nagad: data.nagad,
        };
        await submit(paymentsSettings);
    };
    
    const onNagadSubmit = async data => {
        setIsSubmitting(true);
        const paymentsSettings = {
            // bank_dbbl: data.bank_dbbl,
            // bkash: data.bkash,
            // rocket: data.rocket,
            nagad: data.nagad,
        };
        await submit(paymentsSettings);
    };

    const submit = async (data) => {

        await db
        .collection(SETTINGS_COLLECTION)
        .doc('payments')
        .update(data);

        setIsSubmitting(false);
        return history.replace("/profile");
    }

    const fetchPaymentsSettings = async () => {
        setLoading(true);
        await db
        .collection(SETTINGS_COLLECTION)
        .doc('payments')
        .get()
        .then(doc => {
            if(doc.exists) {
                // console.log(doc.data());
                let data = {
                    bank_dbbl: doc.data()?.bank_dbbl,
                    bkash: doc.data()?.bkash,
                    rocket: doc.data()?.rocket,
                    nagad: doc.data()?.nagad
                };

                setPayments(data);
            }
        });
        setLoading(false);
    }

    useEffect(() => {
        // const controller = new AbortController();
        // controller.abort();
        return fetchPaymentsSettings();
    }, [])

    return loading ? <LoadingIndicator /> : payments !== null && (
        <div>
            <div className="flex w-full justify-between items-center bg-blue-400 py-4 px-4 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow">
                <button onClick={() => history.goBack()} className=" text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
                    </svg>
                </button>
                <p className="m-auto inset-0 text-xl font-semibold leading-7 text-center text-gray-200">{isSubmitting ? 'Processing...' : 'Payment Settings'}</p>
                {isSubmitting && (
                        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        
                    ) }
            </div>
            <form className="bg-blue-400 shadow-lg rounded-lg p-8 m-2 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow-lg" onSubmit={handleSubmit(onBankSubmit)}>
                <label className="block text-xl text-gray-300">DBBL Bank Account</label>
                <br/>
                <div className="flex space-x-1 ">
                    <div className="w-full">
                        <input  {...register("bank_dbbl", { required: true })} defaultValue={payments.bank_dbbl} type="text" placeholder="DBBL Bank Account Number" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-lg outline-none py-1 px-3 leading-8 transition-colors duration-200 ease-in-out text-white backdrop-filter backdrop-blur-lg bg-opacity-5 overflow-hidden"/>
                        {/* errors will return when field validation fails  */}
                        {errors.bank_dbbl && <span className="text-red-300">This field is required</span>}
                    </div>
                    
                    <button type="submit" className="px-4 py-2 border border-transparent text-center leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">SAVE</button>
                </div>
            </form>
            <form className="bg-blue-400 shadow-lg rounded-lg p-8 m-2 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow-lg" onSubmit={handleSubmit(onBkashSubmit)}>
                <label className="block text-xl text-gray-300">Bkash Account</label>
                <br/>
                <div className="flex space-x-1 ">
                    <div className="w-full">
                        <input  {...register("bkash", { required: true })} defaultValue={payments.bkash} type="text" placeholder="Bkash Account Number" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-lg outline-none py-1 px-3 leading-8 transition-colors duration-200 ease-in-out text-white backdrop-filter backdrop-blur-lg bg-opacity-5 overflow-hidden"/>
                        {/* errors will return when field validation fails  */}
                        {errors.bkash && <span className="text-red-300">This field is required</span>}
                    </div>
                    
                    <button type="submit" className="px-4 py-2 border border-transparent text-center leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">SAVE</button>
                </div>
            </form>
            <form className="bg-blue-400 shadow-lg rounded-lg p-8 m-2 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow-lg" onSubmit={handleSubmit(onRocketSubmit)}>
                <label className="block text-xl text-gray-300">Rocket Account</label>
                <br/>
                <div className="flex space-x-1 ">
                    <div className="w-full">
                        <input  {...register("rocket", { required: true })} defaultValue={payments.rocket} type="text" placeholder="Rocket Account Number" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-lg outline-none py-1 px-3 leading-8 transition-colors duration-200 ease-in-out text-white backdrop-filter backdrop-blur-lg bg-opacity-5 overflow-hidden"/>
                        {/* errors will return when field validation fails  */}
                        {errors.rocket && <span className="text-red-300">This field is required</span>}
                    </div>
                    
                    <button type="submit" className="px-4 py-2 border border-transparent text-center leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">SAVE</button>
                </div>
            </form>
            <form className="bg-blue-400 shadow-lg rounded-lg p-8 m-2 backdrop-filter backdrop-blur-lg bg-opacity-20 overflow-hidden shadow-lg" onSubmit={handleSubmit(onNagadSubmit)}>
                <label className="block text-xl text-gray-300">Nagad Account</label>
                <br/>
                <div className="flex space-x-1 ">
                    <div className="w-full">
                        <input  {...register("nagad", { required: true })} defaultValue={payments.nagad} type="text" placeholder="Nagad Account Number" className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-lg outline-none py-1 px-3 leading-8 transition-colors duration-200 ease-in-out text-white backdrop-filter backdrop-blur-lg bg-opacity-5 overflow-hidden"/>
                        {/* errors will return when field validation fails  */}
                        {errors.nagad && <span className="text-red-300">This field is required</span>}
                    </div>
                    
                    <button type="submit" className="px-4 py-2 border border-transparent text-center leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">SAVE</button>
                </div>
            </form>
        </div>
    );
}
 
export default PaymentSettingPage;